import { copyApiPrefilterPerRole } from "@shared/backend/entity-security/copy-api-prefilter-per-role";
import type { HyperEntityConfig } from "@shared/backend/hyper-entity.decorator";
import { Roles } from "@shared/Roles";
import { remult } from "remult";
import { Association } from "../association/entity";
import { type AssociationPosition } from "./entity";

export const AssociationPositionEntityConfig: HyperEntityConfig<AssociationPosition> =
  {
    allowApiRead: Roles.All,
    allowApiCrud: Roles.All,
    apiPrefilterPerRole: async (filter) => {
      if (!remult.user) return;
      filter(Roles.All, {
        $or: [
          {
            association: {
              $is: await copyApiPrefilterPerRole(Association),
            },
          },
        ],
      });
    },

    allowInsertPerRole(allow) {
      allow([Roles.User], (entity) =>
        remult.user!.associations!.some(
          (association) => association === entity.associationId,
        ),
      );
    },

    allowDeleteAndUpdatePerRole(allow) {
      allow([Roles.User], (entity) =>
        remult.user!.associations!.some(
          (association) => association === entity.associationId,
        ),
      );
    },
    id: ["associationId", "subCategoryId"],
  };
